import { asyncCallback } from "../utils/analysis-async";
import { StepProcess } from "../interfaces/stepProcess";
import { DomainDTO, NodeData, ResultInfo } from "../models/shared.model";
import { StepResult } from "../models/step-result";
import { MailUtils } from "../utils/mail.utils";
import { StringUtils } from "../utils/string.utils";

export class IsQRCodeLinkDeceptive extends StepProcess {
  process = async (data?: NodeData, info?: ResultInfo): Promise<any> => {
    return asyncCallback<any>(async (resolve) => {
      let result = false

      const deceptive = this.linksService.isLinkDeceptive(data.qrCode?.decoded);

      let reasonLog = this.translate.instant("qr_code_flow.is_deceptive_false");

      if (deceptive) {
        reasonLog = this.translate.instant('qr_code_flow.is_deceptive_true', { url: deceptive });
        result = true;
        info = { ...info, qrCodeDeceptiveLink: deceptive, isConcerning: true }
      }

      resolve(new StepResult(result, reasonLog, info));
    });
  };
}

export class AreQRCodeLinksSecure extends StepProcess {
  process = async (data?: NodeData, info?: ResultInfo): Promise<any> => {

    return asyncCallback<any>(async (resolve, reject) => {
      try {
        const href = info.qrCodeDeceptiveLink ?? data.qrCode?.decoded;

        if (href && !href.startsWith("https://")) {
          if (info.isConcerning == undefined) {
            info = { ...info, isConcerning: true };
          }

          resolve(new StepResult(false, this.translate.instant('qr_code_flow.qr_code_link_starts_with_http'), {
            ...info, qrCodeLinkSecure: false
          }));
        } else
          resolve(new StepResult(true, this.translate.instant('qr_code_flow.qr_code_no_link'), {
            ...info, qrCodeLinkSecure: true
          }));
      } catch (e) {
        console.log(this.translate.instant('qr_code_flow.error_in_are_qr_code_links_secure', {error: e}));
        reject(e);
      }
    });
  };
}

export class IsQRCodeDestinationTrustedDomain extends StepProcess {
  process = async (data?: NodeData, info?: ResultInfo): Promise<any> => {
    return asyncCallback<any>(async (resolve, reject) => {
      try {
        let trustedDomains: DomainDTO[] = this.domainService.getDomains();
        const href = info.qrCodeDeceptiveLink ?? data.qrCode?.decoded;

        if (href) {
          const linkDomain: string = MailUtils.parseMultiLevelDomain(href);

          const res = trustedDomains.some(value =>
            StringUtils.compareCaseInsensitive(value.domain, linkDomain));

          if (info.isConcerning == undefined) {
            info = { ...info, isConcerning: res };
          }

          let reasonLog = this.translate.instant(
              res ? 'qr_code_flow.trusted_domain' : 'qr_code_flow.untrusted_domain',
              { domain: linkDomain }
          );

          resolve(new StepResult(res, reasonLog, { ...info, qrCodeLinkDomainTrusted: res }));
        }
        resolve(new StepResult(true, this.translate.instant('qr_code_flow.link_does_not_have_url'), { ...info, qrCodeLinkDomainTrusted: true }));
      } catch (e) {
        console.log(this.translate.instant('qr_code_flow.error_in_qr_destination_trusted_domain', {error: e}));
        reject(e);
      }
    });
  };
}
